<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div>
      <vx-card ref="filterCard" class="user-list-filters mb-8" collapse-action>
        <ValidationObserver v-slot="{ invalid }">
          <div class="vx-row mb-2">
            <div class="vx-col w-1/3 flex">
              <div class="flex-1 pr-1">
                <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.year") }}</label>
                <v-select v-model="form.year" @change="onChangeYears($event)" :clearable="false" :options="yearsOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
              <div class="flex-1">
                <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.month") }}</label>
                <v-select v-model="form.month" :clearable="false" :options="monthsOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              </div>
            </div>
            <div class="vx-col w-1/3">
              <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.reportType") }}</label>
              <v-select v-model="form.reportType" :clearable="false" :options="reportTypesOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col w-1/3">
              <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.project") }}</label>
              <v-select v-model="form.project" :clearable="true" :options="projectOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
              <label class="text-sm opacity-75">{{$t('sections.report.dataForm.faculty')}}/{{$t('sections.report.dataForm.curriculum')}}</label>
              <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col w-1/3">
              <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.loan.loanType") }}</label>
              <v-select v-model="form.loanType" :clearable="true" :options="loanTypesOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="vx-col w-1/3">
              <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.educationStatus") }}</label>
              <v-select v-model="form.educationStatus" :clearable="true" :options="educationStatusesOptions" name="borrowers" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-row mb-2 flex">
            <div class="vx-col ml-auto">
              <vs-button color='success' @click="download(invalid)" class="mr-2">{{ $t("general.download") }}</vs-button>
              <vs-button color='warning' @click="reset(invalid)">{{ $t("general.reset") }}</vs-button>
            </div>
          </div>
        </ValidationObserver>
      </vx-card>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createNamespacedHelpers, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { round, getReportDate } from '@/utils'
const { mapActions: mapReportActions, mapState: mapReportState } = createNamespacedHelpers('Report')
const { mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')
const moment = require('moment');

export default {
  components: {
    vSelect
  },
  data () {
    return {
      form:{
        year: getReportDate().year,
        month: getReportDate().month,
        reportType: "Summary",
        project: "",
        curriculum: "",
        loanType: "",
        educationStatus: "",
        contractStatus: "",
      },
      user: ""
    }
  },
  computed: {
    ...mapReportState([ 'status']),
    ...mapMasterState(["curriculums", "months"]),
    ...mapGetters({
      yearsOptions: "Master/yearsOptions",
      monthsOptions: "Master/monthsOptions",
      reportTypesOptions: "Master/reportTypesOptions",
      projectOptions: "Master/projectOptions",
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      loanTypesOptions: "Master/loanTypesOptions",
      educationStatusesOptions: "Master/educationStatusesOptions",
      contractStatusesOptions: "Master/contractStatusesOptions",
    }),
    reportName(){
      const month = this.months.find(res =>{
        return res.value === this.form.month
      })
      let monthName = month.label
      return `${this.reportTypesOptions.find(res => res.value === this.form.reportType).label} ณ เดือน${monthName} ${this.form.year}`
    }
  },
  methods: {
    ...mapReportActions(['clearReportDatas', 'getReportSummary', 'getReportSummaryEir', 'getReportSummaryForecast', 'getReportSummaryRemittance']),
    ...mapMasterActions(['onChangeYears', 'getProjectOptions', 'getCurriculumOptions']),
    async loadOptions() {
      const vm = this
      const { getProjectOptions, getCurriculumOptions } = vm
      if(vm.projectOptions.length === 0) await getProjectOptions()
      if(vm.facultyCurriculumOptions.length === 0) await getCurriculumOptions()
    },
    async initData() {

    },
    async download (){
      const vm = this;
      const { form, callSummary, callSummaryForecast, callSummaryRemittance } = vm;
      const { reportType } = form;
      if(reportType === "Summary"){
        await callSummary();
      }else if(reportType === "SummaryForecast"){
        await callSummaryForecast();
      }else if(reportType === "SummaryRemittance"){
        await callSummaryRemittance();
      }else {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid report type',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    },
    async callSummary() {
      const vm = this
      const {getReportSummary} = vm
      const reportDatas = await getReportSummary({
        form: {
          year: this.form.year,
          month: this.form.month,
          project: {id: vm.form.project || ''},
          curriculum: {id: vm.form.curriculum || ''},
          loanType: vm.form.loanType || 'Null',
          educationStatus: vm.form.educationStatus || 'Null',
          contractStatus: vm.form.contractStatus || 'Null',
        }
      })
      if(reportDatas){
        const headerTitle = [
          "ลำดับ",
          "เลขที่บัตรประชาชน",
          "เลขที่สัญญา",
          "ชื่อสัญญา",
          "หลักสูตร",
          'ประเภทการกู้',
          'สถานะนักศึกษา',
          'วันที่จบการศึกษา',
          'สถานะสัญญา',
          'วันที่ปิด',
          'วันที่กู้เงิน',
          "ยอดเงินกู้ตามจริง",
          "ยอดดอกเบี้ยรับล่วงหน้ายกมา",
          "ยอดชำระปัจจุบัน",
          "ชำระค่าธรรมเนียมปัจจุบัน",
          "ชำระเบี้ยปรับปัจจุบัน",
          "ชำระดอกเบี้ยปัจจุบัน",
          "ชำระเงินต้นปัจจุบัน",
          "ดอกเบี้ยรับล่วงหน้ายกไป",
          "รวมยอดรับชำระทั้งสิ้น",
          "รวมชำระค่าธรรมเนียมทั้งสิ้น",
          "รวมชำระเบี้ยปรับทั้งสิ้น",
          "รวมชำระดอกเบี้ยทั้งสิ้น",
          "รวมชำระเงินต้นทั้งสิ้น",
          "ค่าธรรมเนียมคงเหลือ",
          "เบี้ยปรับคงเหลือ",
          'ดอกเบี้ยคงเหลือ',
          "เงินต้นคงเหลือ",
          'วันที่ค้างชำระ',
          'จำนวนวันค้างชำระ',
          'ลำดับชั้นลูกหนี้'
        ]
        const headerVal = [
          "no",
          "idCardNumber",
          "contractNo",
          "contractName",
          "curriculum",
          'loanType',
          'educationStatus',
          'forecastDate',
          'contractStatus',
          'closeDate',
          'assessmentDate',
          "loanAmount",
          "balance",
          "paymentAmount",
          "paidAccruedFee",
          "paidAccruedPenalty",
          "paidAccruedInterest",
          "paidPrinciple",
          "balanceRemain",
          "totalPaymentAmount",
          "totalPaidAccruedFee",
          "totalPaidAccruedPenalty",
          "totalPaidAccruedInterest",
          "totalPaidPrinciple",
          "accruedFeeRemain",
          "accruedPenaltyRemain",
          'accruedInterestRemain',
          "principleRemain",
          'agingDate',
          'agingNumber',
          'hierarchy'
        ]
        const wscols = [
          {wch: 5}, {wch: 16}, {wch: 16}, {wch: 27}, {wch: 30}, {wch: 34},
          {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20},
          {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20},
          {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20},
          {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20},
          {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}, {wch: 20}
        ]
        import('@/vendor/Export2Excel').then(async excel => {
          const data = this.formatJson(headerVal, reportDatas)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: `${vm.reportName}`,
            autoWidth: false,
            bookType: "xlsx",
            wscols
          })
        })
      }
    },
    async callSummaryForecast(){
      const vm = this;
      const { getReportSummaryForecast } = vm
      const reportDatas = await getReportSummaryForecast({
        form: {
          year: this.form.year,
          month: this.form.month,
          project: {id: vm.form.project || ''},
          curriculum: {id: vm.form.curriculum || ''},
          loanType: vm.form.loanType || 'Null',
          educationStatus: vm.form.educationStatus || 'Null',
          contractStatus: vm.form.contractStatus || 'Null',
        }
      })
      if(reportDatas){
        const headerTitle = [
          "ลำดับ",
          "เลขที่สัญญา",
          "ชื่อสัญญา",
          "หลักสูตร",
          'ประเภทการกู้',
          'สถานะนักศึกษา',
          'สถานะสัญญา',
          "เงินกู้ตามจริง",
          "เงินต้น",
          "อัตราดอกเบี้ย",
          "ยอดชำระ",
          "ชำระดอกเบี้ย",
          "ชำระเงินต้น",
          "เงินต้นคงเหลือ",
          'วันที่ค้างชำระ',
          'จำนวนวันค้างชำระ',
          'ลำดับชั้นลูกหนี้'
        ]
        const headerVal = [
          "no",
          "contractNo",
          "contractName",
          "curriculum",
          'loanType',
          'educationStatus',
          'contractStatus',
          "loanAmount",
          'principle',
          "interestRate",
          "paymentAmount",
          "paidInterest",
          "paidPrinciple",
          "principleRemain",
          'agingDate',
          'agingNumber',
          'hierarchy'
        ]
        import('@/vendor/Export2Excel').then(async excel => {
          const data = this.formatJson(headerVal, reportDatas)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: `${vm.reportName}`,
            autoWidth: false,
            bookType: "xlsx",
            wscols: []
          })
        })
      }
    },
    async callSummaryRemittance(){
      const vm = this
      const { getReportSummaryRemittance } = vm
      const reportDatas = await getReportSummaryRemittance({
        form: {
          year: this.form.year,
          month: this.form.month,
          project: {id: vm.form.project || ''},
          curriculum: {id: vm.form.curriculum || ''},
          loanType: vm.form.loanType || 'Null',
          educationStatus: vm.form.educationStatus || 'Null',
          contractStatus: vm.form.contractStatus || 'Null',
        }
      })
      if(reportDatas){
        const headerTitle = [
          "ลำดับ",
          "เลขที่สัญญา",
          "รหัสนักศึกษา",
          "เลขที่บัญชี",
          "ชื่อ-สกุล",
          "มหาวิทยาลัย",
          "คณะ",
          "สถานะสัญญา",
          "ประเภทการกู้",
          "วันที่นำส่ง (ค่าเทอม)",
          "ยอดเงินนำส่ง (ค่าเทอม)",
          "วันที่นำส่ง (ค่าครองชีพ)",
          "ยอดเงินนำส่ง (ค่าครองชีพ)",
          "หมายเหตุ",
          "วันที่ค้างชำระ",
          "ยอดค้างชำระ (ณ ปัจจุบัน)",
          "ค่าธรรมเนียม",
          "เบี้ยปรับ",
        ]
        const headerVal = [
          "no",
          "contractNo",
          "studentCode",
          "accoNo",
          "contractName",
          "project",
          "facultyCurriculum",
          "contractStatus",
          "loanType",
          "tuitionFeeDate",
          "tuitionFeeAmount",
          "costOfLivingDate",
          "costOfLivingAmount",
          "remark",
          "agingDate",
          "outstandingBalanceRemain",
          "accruedFeeRemain",
          "accruedPenaltyRemain",
        ]
        const wscols = [
          {wch:5},{wch:15},{wch:15},{wch:30},{wch:25},
          {wch:20},{wch:35},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20},{wch:20},{wch:20},
          {wch:20},{wch:20},{wch:20}
          ,      ]
        import('@/vendor/Export2Excel').then(async excel => {
          const data = this.formatJson(headerVal, reportDatas)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: `${vm.reportName}`,
            autoWidth: false,
            bookType: "xlsx",
            wscols
          })
        })
      }
    },
    async reset(){
      this.form = {
        year: moment().add(-1, 'M').format("YYYY"),
        month: parseInt(moment().add(-1, 'M').format("MM"))-1,
        reportType: "Summary",
        educationStatus: '',
        loanType: '',
        project: '',
        curriculum: '',
      }
    },
    formatJson (filterVal, jsonData) {
      const roundArr = [
          "loanAmount",
          "balance",
          "paymentAmount",
          "paidAccruedFee",
          "paidAccruedPenalty",
          "paidAccruedInterest",
          "paidPrinciple",
          "balanceRemain",
          "totalPaymentAmount",
          "totalPaidAccruedFee",
          "totalPaidAccruedPenalty",
          "totalPaidAccruedInterest",
          "totalPaidPrinciple",
          "accruedFeeRemain",
          "accruedPenaltyRemain",
          'accruedInterestRemain',
          "principleRemain"
      ]
      const dateArr = ['forecastDate', 'assessmentDate', 'agingDate', 'closeDate', 'tuitionFeeDate', 'costOfLivingDate']
      return jsonData.map((res, index) => filterVal.map(col => {
        if (col === 'no') {
          return index+1
        }else if (col === 'loanType') {
          return this.$options.filters.loanType(res[col]);
        }else if (col === 'educationStatus') {
          return this.$options.filters.educationStatus(res[col]);
        }else if (col === 'contractStatus') {
          return this.$options.filters.contractStatus(res[col]);
        }else if(col === 'hierarchy'){
          return this.$options.filters.hierarchy(res)
        }else if (dateArr.includes(col)) {
          const timestamp = Date.parse(res[col]);
          let date = "-"
          if (isNaN(timestamp) === false) date = new Date(timestamp);
          return date
        }else if (roundArr.includes(col)) {
          return round(res[col], 4);
        }else {
           return res[col]
        }
      }))
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    await vm.loadOptions();
    await vm.initData();
    vm.$vs.loading.close();
  },
}
</script>
